import { render, staticRenderFns } from "./adminModal.vue?vue&type=template&id=1843a03a"
import script from "./adminModal.vue?vue&type=script&lang=js"
export * from "./adminModal.vue?vue&type=script&lang=js"
import style0 from "./adminModal.vue?vue&type=style&index=0&id=1843a03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports